/* ============================================================
   STREIM theme interactions
   ============================================================ */
(function () {
  'use strict';
  var STREIM = window.STREIM || {};
  var routes = STREIM.routes || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(type, sel, handler) {
    document.addEventListener(type, function (e) {
      var el = e.target.closest(sel);
      if (el) handler(e, el);
    });
  }

  /* ---------------- Announcement bar rotation ---------------- */
  function initAnnouncement() {
    var bar = $('.announcement-bar');
    if (!bar) return;
    var msgs = $all('.announcement-msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    var interval = parseInt(bar.getAttribute('data-rotate-interval'), 10) || 4000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, interval);
  }

  /* ---------------- Overlay helpers ---------------- */
  function openDrawer(drawer, scrim) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(drawer, scrim) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function closeAll() {
    $all('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    $all('.overlay-scrim.is-open').forEach(function (s) { s.classList.remove('is-open'); });
    document.body.style.overflow = '';
  }

  function initOverlays() {
    // Cart
    on('click', '[data-cart-open]', function (e) { e.preventDefault(); openDrawer($('[data-cart-drawer]'), $('[data-cart-scrim]')); });
    on('click', '[data-cart-close]', function () { closeDrawer($('[data-cart-drawer]'), $('[data-cart-scrim]')); });
    on('click', '[data-cart-scrim]', function () { closeDrawer($('[data-cart-drawer]'), $('[data-cart-scrim]')); });
    // Menu
    on('click', '[data-menu-open]', function (e) { e.preventDefault(); openDrawer($('[data-mobile-menu]'), $('[data-menu-scrim]')); });
    on('click', '[data-menu-close]', function () { closeDrawer($('[data-mobile-menu]'), $('[data-menu-scrim]')); });
    on('click', '[data-menu-scrim]', function () { closeDrawer($('[data-mobile-menu]'), $('[data-menu-scrim]')); });
    // Search
    on('click', '[data-search-open]', function (e) {
      e.preventDefault();
      closeDrawer($('[data-mobile-menu]'), $('[data-menu-scrim]'));
      openDrawer($('[data-search-modal]'), $('[data-search-scrim]'));
      var input = $('[data-search-input]');
      if (input) setTimeout(function () { input.focus(); }, 120);
    });
    on('click', '[data-search-close]', function () { closeDrawer($('[data-search-modal]'), $('[data-search-scrim]')); });
    on('click', '[data-search-scrim]', function () { closeDrawer($('[data-search-modal]'), $('[data-search-scrim]')); });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------------- Predictive search ---------------- */
  function initPredictive() {
    var input = $('[data-search-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results || !routes.predictive_search) return;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        var url = routes.predictive_search + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=';
        fetch(routes.predictive_search + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { results.innerHTML = '<div class="cart-empty">No matches.</div>'; return; }
            results.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">' : '<span></span>';
              return '<a class="predictive-item" href="' + p.url + '">' + img +
                '<span class="predictive-title">' + p.title + '</span>' +
                '<span class="predictive-price">' + (p.price ? p.price : '') + '</span></a>';
            }).join('');
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------------- Cart ---------------- */
  function setLoading(el, on) { if (el) el.style.opacity = on ? '.5' : ''; if (el) el.style.pointerEvents = on ? 'none' : ''; }

  function refreshCartUI() {
    return fetch(window.location.pathname + '?sections=cart-drawer', { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (html != null) {
          var wrap = document.getElementById('shopify-section-cart-drawer');
          var wasOpen = $('[data-cart-drawer]') && $('[data-cart-drawer]').classList.contains('is-open');
          if (wrap) {
            wrap.innerHTML = html;
            if (wasOpen) { var d = $('[data-cart-drawer]'); var s = $('[data-cart-scrim]'); if (d) d.classList.add('is-open'); if (s) s.classList.add('is-open'); }
          }
        }
        return fetch(routes.cart || '/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        $all('[data-cart-count]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
        $all('[data-cart-count-drawer]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
      })
      .catch(function () {});
  }

  function cartAdd(id, qty, btn) {
    setLoading(btn, true);
    return fetch(routes.cart_add || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        setLoading(btn, false);
        if (!res.ok) { alert(res.body && res.body.description ? res.body.description : 'Could not add to cart.'); return; }
        return refreshCartUI().then(function () { openDrawer($('[data-cart-drawer]'), $('[data-cart-scrim]')); });
      }).catch(function () { setLoading(btn, false); });
  }

  function cartChange(key, qty) {
    return fetch(routes.cart_change || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCartUI(); });
  }

  function initCart() {
    // qty + / -
    on('click', '[data-qty-up]', function (e) {
      var line = e.target.closest('[data-key]'); if (!line) return;
      var input = $('[data-qty-input]', line);
      cartChange(line.getAttribute('data-key'), parseInt(input.value, 10) + 1);
    });
    on('click', '[data-qty-down]', function (e) {
      var line = e.target.closest('[data-key]'); if (!line) return;
      var input = $('[data-qty-input]', line);
      cartChange(line.getAttribute('data-key'), Math.max(0, parseInt(input.value, 10) - 1));
    });
    on('click', '[data-line-remove]', function (e) {
      var line = e.target.closest('[data-key]'); if (!line) return;
      cartChange(line.getAttribute('data-key'), 0);
    });

    // product add-to-cart (intercept)
    var form = $('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = $('[data-variant-id]', form).value;
        cartAdd(id, 1, $('[data-atc]', form));
      });
    }
    // sticky add
    on('click', '[data-sticky-add]', function () {
      var f = $('[data-product-form]'); if (!f) return;
      var id = $('[data-variant-id]', f).value;
      cartAdd(id, 1, $('[data-sticky-add]'));
    });
  }

  /* ---------------- PDP variant selection ---------------- */
  function initProduct() {
    var root = $('[data-product-root]');
    var jsonEl = $('[data-product-json]');
    var form = $('[data-product-form]');
    if (!root || !jsonEl || !form) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var optionGroups = $all('.pdp-opt', form);
    var optCount = optionGroups.length;
    var selected = [];
    var idInput = $('input[name="id"]', form) || $('[data-variant-id]', form);
    var atc = $('[data-atc]', form);
    var atcText = $('[data-atc-text]', form);
    var priceEl = $('[data-price]');
    var compareEl = $('[data-compare]');
    var stickyPrice = $('[data-sticky-price]');
    var stickyAdd = $('[data-sticky-add]');
    var configuredLabel = data.atc_label || 'ADD TO CART →';
    var readyLabel = configuredLabel.toUpperCase().indexOf('SELECT') !== -1 ? 'ADD TO CART →' : configuredLabel;
    var selectLabel = 'SELECT OPTIONS';

    function paintOptionButton(btn, on) {
      if (!btn) return;
      if (on) {
        btn.style.setProperty('background', '#0a0a0a', 'important');
        btn.style.setProperty('background-color', '#0a0a0a', 'important');
        btn.style.setProperty('color', '#fffdf8', 'important');
        btn.style.setProperty('border-color', '#0a0a0a', 'important');
        btn.style.setProperty('box-shadow', 'inset 0 0 0 999px #0a0a0a', 'important');
        var label = btn.querySelector('span');
        if (label) label.style.setProperty('color', '#fffdf8', 'important');
      } else {
        btn.style.removeProperty('background');
        btn.style.removeProperty('background-color');
        btn.style.removeProperty('color');
        btn.style.removeProperty('border-color');
        btn.style.removeProperty('box-shadow');
        var resetLabel = btn.querySelector('span');
        if (resetLabel) resetLabel.style.removeProperty('color');
      }
    }

    optionGroups.forEach(function (opt) {
      var active = $('.pdp-opt-btn.active', opt);
      if (!active) {
        var availableBtns = $all('.pdp-opt-btn:not([disabled])', opt).filter(function (btn) {
          return btn.getAttribute('aria-disabled') !== 'true';
        });
        if (availableBtns.length === 1) {
          active = availableBtns[0];
          active.setAttribute('aria-pressed', 'true');
          active.classList.add('active');
          var initialLabel = $('[data-option-selected]', opt);
          if (initialLabel) initialLabel.textContent = active.getAttribute('data-value');
        }
      }
      if (active) paintOptionButton(active, true);
      selected.push(active ? active.getAttribute('data-value') : null);
    });

    function findVariant() {
      if (selected.some(function (s) { return s == null; })) return null;
      return variants.find(function (v) {
        return v.options.every(function (val, idx) { return val === selected[idx]; });
      }) || null;
    }

    function displayOptionValue(value) {
      return value === 'Gray' ? 'Grey' : value;
    }

    function apply(v) {
      if (!v) {
        if (atc) { atc.disabled = true; atc.setAttribute('disabled', 'disabled'); }
        if (atcText) atcText.textContent = selectLabel;
        if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.setAttribute('disabled', 'disabled'); stickyAdd.textContent = selectLabel; }
        return;
      }
      if (idInput) {
        idInput.value = v.id;
        idInput.setAttribute('value', v.id);
      }
      if (priceEl) priceEl.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (compareEl) compareEl.textContent = v.compare_at_price || '';
      if (v.image) { var mainImg = $('#pdp-main-img'); if (mainImg) mainImg.src = v.image; }
      if (v.media_index != null) galleryGo(v.media_index);
      if (v.available) {
        if (atc) { atc.disabled = false; atc.removeAttribute('disabled'); }
        if (atcText) atcText.textContent = readyLabel;
        if (stickyAdd) { stickyAdd.disabled = false; stickyAdd.removeAttribute('disabled'); stickyAdd.textContent = readyLabel; }
      } else {
        if (atc) { atc.disabled = true; atc.setAttribute('disabled', 'disabled'); }
        if (atcText) atcText.textContent = 'SOLD OUT';
        if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.setAttribute('disabled', 'disabled'); stickyAdd.textContent = 'SOLD OUT'; }
      }
      var sc = $('[data-pdp-scarcity]');
      if (sc) {
        if (v.available && v.managed && v.inventory > 0 && v.inventory <= (data.scarcity_threshold || 6)) {
          var sizeIdx = typeof data.size_option_index === 'number' ? data.size_option_index : -1;
          var sizeText = sizeIdx >= 0 && v.options && v.options[sizeIdx] ? ' IN SIZE ' + v.options[sizeIdx] : '';
          sc.style.display = '';
          sc.innerHTML = '<span class="dot"></span> ' + v.inventory + ' LEFT' + sizeText;
        } else { sc.style.display = 'none'; }
      }
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    on('click', '.pdp-opt-btn', function (e, sw) {
      if (sw.disabled || sw.getAttribute('aria-disabled') === 'true') return;
      var opt = sw.closest('.pdp-opt');
      if (!opt) return;
      var idx = parseInt(opt.getAttribute('data-option-index'), 10);
      $all('.pdp-opt-btn', opt).forEach(function (s) {
        s.setAttribute('aria-pressed', 'false');
        s.classList.remove('active');
        paintOptionButton(s, false);
      });
      sw.setAttribute('aria-pressed', 'true'); sw.classList.add('active');
      paintOptionButton(sw, true);
      var selLabel = $('[data-option-selected]', opt);
      if (selLabel) selLabel.textContent = displayOptionValue(sw.getAttribute('data-value'));
      selected[idx] = sw.getAttribute('data-value');
      apply(findVariant());
    });

    // Only gate when there are options to choose; single-variant stays server-enabled.
    if (optCount > 0) apply(findVariant());
  }

  /* ---------------- PDP gallery (thumbs + arrows) ---------------- */
  var galleryGo = function () {};
  function initGallery() {
    var thumbs = $all('[data-thumb]');
    var mainImg = $('#pdp-main-img');
    if (!mainImg) return;
    var counter = $('[data-image-counter]');
    var total = thumbs.length || 1;
    var idx = 0;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function show(i) {
      if (!total) return;
      idx = (i + total) % total;
      var t = thumbs[idx];
      if (t) {
        var full = t.getAttribute('data-full');
        if (full) mainImg.src = full;
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        t.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
      if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(total);
    }
    galleryGo = function (i) { if (i >= 0 && i < total) show(i); };
    on('click', '[data-thumb]', function (e, thumb) {
      show(parseInt(thumb.getAttribute('data-index'), 10) || 0);
    });
    on('click', '[data-gallery-prev]', function () { show(idx - 1); });
    on('click', '[data-gallery-next]', function () { show(idx + 1); });
  }

  /* ---------------- PDP scroll progress ---------------- */
  function initScrollProgress() {
    var bar = $('[data-scroll-progress]');
    if (!bar) return;
    function update() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var p = max > 0 ? (h.scrollTop || window.pageYOffset) / max : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)) + ')';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------------- Collection sort ---------------- */
  function initSort() {
    var sel = $('[data-sort-select]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }

  /* ---------------- Scroll reveal ---------------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var els = $all('[data-reveal]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Collection / archive title: fit one line + stagger ---------------- */
  function initCollectionTitle() {
    var t = $('.collection-hero-v2 .collection-title');
    if (!t) return;
    var chs = $all('.ch', t);
    if (!chs.length) return;

    // Length-independent rise stagger. CSS only defines delays for the first
    // 7 chars (sized for "ARCHIVE"), so longer titles like "KINETIC RUNNERS"
    // never staggered in — set an even delay per character index instead.
    chs.forEach(function (ch, i) { ch.style.animationDelay = (0.05 + i * 0.045).toFixed(3) + 's'; });

    // Scale the title so its single line fills — but never overflows — the
    // column, whatever the title length (ARCHIVE vs PRIMO BASKET SUEDE).
    function fit() {
      var host = t.parentNode; // .collection-hero-left
      if (!host) return;
      // Measure available width with the title tiny so a long nowrap line
      // can't blow out the grid track during measurement.
      t.style.fontSize = '10px';
      var avail = host.clientWidth;
      if (!avail) { t.style.fontSize = ''; return; }
      t.style.fontSize = '100px';
      var natural = chs[chs.length - 1].getBoundingClientRect().right - chs[0].getBoundingClientRect().left;
      if (natural <= 0) { t.style.fontSize = ''; return; }
      var size = (avail * 0.94) / (natural / 100);
      size = Math.min(size, 240);
      size = Math.max(size, 28);
      t.style.fontSize = size.toFixed(1) + 'px';
    }

    fit();
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fit); }
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fit, 120); });
  }

  /* ---------------- Sticky drop-bar: slide in under the header on scroll ---------------- */
  function initStickyDrop() {
    var bar = $('[data-drop-bar]');
    if (!bar) return;
    function update() {
      var trigger = (window.innerHeight || 600) * 0.6;
      if (window.pageYOffset > trigger) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  function initMailLinks() {
    on('click', '[data-email-support-link]', function (e, el) {
      var href = el.getAttribute('href');
      if (!href || href.indexOf('mailto:') !== 0) return;
      e.preventDefault();
      window.location.href = href;
    });
  }

  /* ---------------- Related (other colorways) carousel arrows ---------------- */
  function initRelated() {
    var track = $('[data-related-track]');
    if (!track) return;
    function step() {
      var card = track.querySelector('.related-card');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }
    on('click', '[data-related-prev]', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    on('click', '[data-related-next]', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });

    // Click-and-drag to slide with the mouse (touch keeps native scroll).
    var down = false, startX = 0, startScroll = 0, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = 0; startX = e.clientX; startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      track.scrollLeft = startScroll - dx;
    });
    function endDrag() { if (!down) return; down = false; track.classList.remove('is-dragging'); }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    // Swallow the click that ends a real drag so cards don't navigate.
    track.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);
    // Don't let images start a native ghost-drag.
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initOverlays();
    initPredictive();
    initCart();
    initGallery();
    initProduct();
    initScrollProgress();
    initSort();
    initReveal();
    initCollectionTitle();
    initRelated();
    initStickyDrop();
    initMailLinks();
  });
})();
